import { API } from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";


export const  getAllTutorial=(query)=>{
  let str=objectToQueryString(query);
  return fetch(`${API}/tutorials?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json'
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const saveTutorial=(userId,token,payload)=>{
  return fetch(`${API}/save/tutorial/${userId}`,{
    method:"put",
    headers:{
      Accept:"application/json",
      'Content-Type':"application/json",
      Authorization:`Bearer ${token}`
    },
    body:JSON.stringify(payload)
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}